/* eslint-disable */
import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppDispatch, RootState } from '../../../store/store';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import DownloadIcon from '@mui/icons-material/Download';
import srv from '../../../services';
import moment from 'moment';
import { storyPaymentReceiptResponseStatus } from '../../../store/reducers/storyPaymentReceiptResponseStatusSlice';

export interface ReceiptData {
 date: string;
 amount: string;
 contractor: string;
 contractNumber: string;
 paymentDate: string;
 paymentSource: string;
 recipient: string;
}

const useStyles = makeStyles()(() => ({
 cursor: {
  display: 'flex',
  flexDirection: 'column',
  WebkitJustifyContent: 'none !important',
  justifyItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  outlineColor: 'white',
  textDecoration: 'underline',
  height: '140px',
  overflow: 'hidden',
  margin: 'auto',
  cursor: 'pointer',
  marginTop: '10px',
 },
}));

interface StoryPaymentReceiptObject {
 errorStatus: boolean;
 message: string;
 show: boolean;
}

/**
 * Сохранить и передать клиенутый id в главную форму.
 * @param props
 * @returns
 */
const SVtoryPaymentDocumentCellRender = (props: any) => {
 const { classes } = useStyles();
 const dispatch = useDispatch<AppDispatch>();

 const contragentData = useSelector(
  (state: RootState) => state.getContragentAllData,
  shallowEqual,
 );

 const contractData = useSelector(
  (state: RootState) => state.getContract,
  shallowEqual,
 );

 //  const handleDownload = async (fileUrl, fileName) => {
 //   try {
 //    const response = await fetch(fileUrl);
 //    if (!response.ok) throw new Error('Ошибка при скачивании файла');

 //    const blob = await response.blob();
 //    const localUrl = window.URL.createObjectURL(blob);

 //    const link = document.createElement('a');
 //    link.href = localUrl;
 //    link.download = fileName || 'download.pdf';
 //    document.body.appendChild(link);
 //    link.click();

 //    document.body.removeChild(link);
 //    window.URL.revokeObjectURL(localUrl);
 //   } catch (error) {
 //    console.error('Не удалось скачать файл:', error);
 //   }
 //  };

 // return (
 //  <a href={fileUrl} onClick={handleDownload}>
 //   Скачать PDF через Fetch
 //  </a>
 // );

 const handleDownloadClick = async (): Promise<void> => {
  const obj: StoryPaymentReceiptObject = {
   errorStatus: true,
   message: '',
   show: false,
  };
  dispatch(storyPaymentReceiptResponseStatus(obj));

  // const dateResult = moment(props?.data?.documetDate, 'DD.MM.YYYY')
  //  .month(3)
  //  .date(16)
  //  .set({ hour: 0, minute: 0, second: 1, millisecond: 0 })
  //  .format('YYYY-MM-DDTHH:mm:ss');

  const dateResult = moment(props?.data?.documetDate, 'DD.MM.YYYY').format(
   'YYYY-MM-DDTHH:mm:ss',
  );

  if (
   props?.data?.paymentType?.toLowerCase().indexOf('личный кабинет') !== -1
  ) {
   const payload = {
    contractId: contractData?.aisId,
    documentDate: dateResult,
    documentNumber: props?.data?.documentNumber,
    paymentAmount: props?.data?.paymentAmount,
   };

   try {
    const receiptData = await srv.requestStoryPaymentReceipt(payload);

    if (receiptData && receiptData.receiptUrl) {
     // const fileName = `Квитанция оплаты от ${props?.data?.documetDate}.pdf`;
     window.open(receiptData.receiptUrl, '_blank', 'noopener,noreferrer');

     //  const obj: StoryPaymentReceiptObject = {
     //   errorStatus: true,
     //   message: 'Чек успешно создан',
     //   show: true,
     //  };
     //  dispatch(storyPaymentReceiptResponseStatus(obj));
    }
   } catch (err) {
    const obj: StoryPaymentReceiptObject = {
     errorStatus: false,
     message: err,
     show: true,
    };
    dispatch(storyPaymentReceiptResponseStatus(obj));
   }
  } else {
   const data = {
    date: props?.data?.documetDate || '-',
    amount: props?.data?.paymentAmount || '-',
    contractor: contragentData?.companyShortName || '-',
    contractNumber: contractData?.printNumber || '-',
    paymentDate: props?.data?.documetDate || '-',
    paymentSource: props?.data?.paymentType || '-',
    recipient: props?.data?.organization || '-',
   };

   const element = document.createElement('div');
   element.style.position = 'absolute';
   element.style.left = '-9999px';
   element.style.top = '0';
   element.style.width = '650px';
   element.style.padding = '40px';
   element.style.backgroundColor = '#ffffff';
   element.style.fontFamily = 'Arial, sans-serif';
   element.style.color = '#282828';

   element.innerHTML = `
    <div style="font-size: 22px; font-weight: bold; margin-bottom: 5px;">Квитанция оплаты от ${data.date} г.</div>
    <div style="font-size: 16px; color: #0066cc; font-weight: bold; margin-bottom: 20px;">На сумму: ${data.amount} руб.</div>
    <div style="border-bottom: 2px solid #0066cc; margin-bottom: 25px; width: 100%;"></div>
    
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">Контрагент:</div>
      <div style="color: #000000; flex: 1;">${data.contractor}</div>
    </div>
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">№ Договора:</div>
      <div style="color: #000000; flex: 1;">${data.contractNumber}</div>
    </div>
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">Дата платежа:</div>
      <div style="color: #000000; flex: 1;">${data.paymentDate}</div>
    </div>
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">Источник платежа:</div>
      <div style="color: #000000; flex: 1;">${data.paymentSource}</div>
    </div>
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">Сумма платежа:</div>
      <div style="color: #000000; flex: 1;">${data.amount} руб.</div>
    </div>
    <div style="display: flex; margin-bottom: 12px; font-size: 14px;">
      <div style="font-weight: bold; width: 180px; color: #555555;">Получатель:</div>
      <div style="color: #000000; flex: 1;">${data.recipient}</div>
    </div>
    
    <div style="margin-top: 40px; padding-top: 15px; border-top: 1px solid #cccccc; font-size: 10px; color: #999999;">
      Документ сформирован автоматически в Личном Кабинете АО ЭК ВОСТОК
    </div>
  `;

   document.body.appendChild(element);

   try {
    const canvas = await html2canvas(element, {
     scale: 2,
     logging: false,
     backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/jpeg', 1.0);

    // Чистый бинарный PDF файл
    const pdf = new jsPDF({
     orientation: 'portrait',
     unit: 'mm',
     format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgWidth = pdfWidth - 30;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, 'JPEG', 15, 15, imgWidth, imgHeight);

    pdf.save(`Квитанция оплаты от ${data.date}.pdf`);

    const obj: StoryPaymentReceiptObject = {
     errorStatus: true,
     message: 'Файл успешно скачан',
     show: true,
    };
    dispatch(storyPaymentReceiptResponseStatus(obj));
   } catch (error) {
    console.error('Файл не сформирован:', error);
   } finally {
    document.body.removeChild(element);
   }
  }
 };

 return (
  <div style={{ display: 'flex' }}>
   <div
    style={{
     display: 'flex',
     flexDirection: 'row',
     justifyContent: 'center',
     justifyItems: 'center',
     alignContent: 'center',
     alignItems: 'center',
     cursor: 'pointer',
    }}
    className={classes.cursor}
    onClick={(e: any) => handleDownloadClick()}
   >
    <DownloadIcon style={{ marginBottom: '10px' }} />
    <label style={{ marginBottom: '15px', cursor: 'pointer' }}>Скачать</label>
   </div>
  </div>
 );
};

export default memo(SVtoryPaymentDocumentCellRender);
